import bigInt from "big-integer";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDefaultCoverImageURL, parseBBCode } from "../_helpers";
import { useTime } from "../_contexts";
import {
  SidebarCover,
  SidebarOptions,
  SidebarTimeline,
  SidebarDateDisplay,
} from "./_components";
import { RelatedArticlesDisplay } from "../_components";

export function SidebarRangeDetails({ item }) {
  const [cover, setCover] = useState(undefined);
  const { items } = useSelector((state) => state.event);
  const { items: markers } = useSelector((state) => state.markers);
  const { items: images } = useSelector((state) => state.images);
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { calendar: globalCalendar } = useTime();

  const bundleItems = items
    ? items
        .filter((ev) => {
          //Do not include the actual base event
          if (ev._id === item._id) return false;
          //Exclude Events from other Timelines
          if (ev.timeline !== item.timeline) return false;
          //Exlude events from other lanes (Make this optional?)
          if (ev.lane !== item.lane) return false;
          // Check if the event's start date is after or equal to the base event's
          if (bigInt(ev.fromDate).greaterOrEquals(item.fromDate)) {
            //Check if the event's start date is before or equal to the base event's
            if (bigInt(ev.fromDate).lesserOrEquals(item.toDate)) {
              //The event at least starts during the base event's timespan

              return true;
            }
          }
          //Need additional logic to determine events that end during the base event
          //Need additional logic to determine events that start before and after the base event
          return false;
        })
        .sort((a, b) => {
          return bigInt(a.fromDate).greater(b.fromDate) ? 1 : -1;
        })
        .map((ev) => {
          const eventItem = { ...ev };
          if (ev.marker) {
            const marker = markers.find((m) => m._id === ev.marker);
            if (marker) {
              eventItem.marker = marker;
            }
          }
          return eventItem;
        })
    : [];

  // console.log('BundleItems', bundleItems);

  useEffect(() => {
    if (item.cover) {
      if (typeof item.cover === "string" && item.cover.length > 0) {
        const image = images.find((i) => i._id === item.cover);
        if (image) {
          setCover(image.url);
        } else {
          //No cover image found, use fallback
          setCover(getDefaultCoverImageURL());
        }
      } else if (item.cover._id) {
        setCover(item.cover.url);
      }
    } else {
      //No Cover Specified, use the Chronicle's default
      const { defaultCover } = chronicle;
      if (defaultCover) {
        if (typeof defaultCover === "string" && defaultCover.length > 0) {
          const image = images.find((i) => i._id === defaultCover);
          if (image) {
            setCover(image.url);
          }
        } else if (defaultCover._id) {
          setCover(defaultCover.url);
        } else {
          setCover(getDefaultCoverImageURL());
        }
      } else {
        setCover(getDefaultCoverImageURL());
      }
    }
  }, [item]);

  // const cover =
  //   item?.cover?.url || 'https://www.worldanvil.com/images/logo-550px.png';

  const cleanedDescription = parseBBCode(item.description);

  return (
    <div className="chronos-sidebar-content chronos-sidebar-eventrange-details-wrapper">
      <SidebarCover url={cover} name={item.title} />
      <div className="chronos-sidebar-body">
        <div className="chronos-sidebar-type">
          <span>Event</span>
        </div>
        <h4 className="chronos-sidebar-title">{item.title}</h4>
        <SidebarDateDisplay
          from={item.fromDate}
          to={item.toDate}
          calendar={
            typeof eventCalendar !== "undefined"
              ? eventCalendar
              : globalCalendar
          }
        />
        <hr className="chronos-sidebar-separator" />
        <div
          className="chronos-sidebar-description"
          dangerouslySetInnerHTML={{ __html: cleanedDescription }}
        ></div>
        {/* Insert Timeline here */}
        <SidebarTimeline events={bundleItems} selectedEvent={item} />
        {item && item.linkedArticles && item.linkedArticles.length > 0 && (
          <React.Fragment>
            <RelatedArticlesDisplay articles={item.linkedArticles} />
          </React.Fragment>
        )}
        <SidebarOptions item={item} type="event" />
      </div>
    </div>
  );
}
